import { TbasService } from './tbas.services';
import { PaycellService } from './paycell.service';
import { AdjustEventService } from './adjust-event.service';
import { MasterpassService } from './masterpass.service';
import { OtpService } from './otp.service';

export default angular
  .module('fizyweb.paycell.payment.services', [])
  .service('paycellService', PaycellService)
  .service('masterpassService', MasterpassService)
  .service('adjustEventService', AdjustEventService)
  .service('tbasService', TbasService)
  .service('otpService', OtpService).name;



// WEBPACK FOOTER //
// src/app/buy/services/payment-services.module.ts